import request from '@/core/http/request'

//新增供应商
export function supplier_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/add',
        method: 'post',
        data: data
    })
}

//查询供应商
export function supplier_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/list',
        method: 'post',
        data: data
    })
}

//查询供应商下拉框
export function supplier_selectList(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/selectList',
        method: 'post',
        data: data
    })
}

//修改供应商
export function supplier_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/update',
        method: 'post',
        data: data
    })
}

//删除供应商
export function supplier_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/delete',
        method: 'post',
        data: data
    })
}

//查询供应商详情
export function supplier_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/view',
        method: 'get',
        params: data
    })
}

// 新增供应商预付款
export function supplierAdvanceDeposit_addMainTable(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierAdvanceDeposit/addMainTable',
        method: 'post',
        data: data
    })
}

// 查询供应商预付款
export function supplierAdvanceDeposit_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierAdvanceDeposit/listMain',
        method: 'post',
        data: data
    })
}

// 删除供应商预付款
export function supplierAdvanceDeposit_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierAdvanceDeposit/delete',
        method: 'post',
        data: data
    })
}

// 查询供应商预付款详情
export function supplierAdvanceDeposit_view(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierAdvanceDeposit/view',
        method: 'get',
        params: data
    })
}

// 新增预付款明细
export function supplierAdvanceDeposit_addChildTable(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierAdvanceDeposit/addChildTable',
        method: 'post',
        data: data
    })
}

// 供应商合并开发票
export function pmgtPurchasesStatementDoc_doMergeInvoicingForStatementPayment(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesStatementDoc/doMergeInvoicingForStatementPayment',
        method: 'post',
        data: data
    })
}

// 供应商合并付款
export function pmgtPurchasesStatementDoc_doMergeCollectionForStatementReceipt(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesStatementDoc/doMergeCollectionForStatementReceipt',
        method: 'post',
        data: data
    })
}

// 根据供应商ID查询预付款明细
export function supplierAdvanceDeposit_queryAmountBySupplierId(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierAdvanceDeposit/queryAmountBySupplierId',
        method: 'post',
        data: data
    })
}

// 待供应商发货列表.
export function smgtConsignmentOrderDocDetail_getSmgtConsignmentOrderDocList(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtConsignmentOrderDocDetail/getSmgtConsignmentOrderDocList',
        method: 'post',
        data: data
    })
}

// 供应商预付款充值  
export function supplierAdvanceDeposit_updateAdvanceDepositAmount(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierAdvanceDeposit/updateAdvanceDepositAmount',
        method: 'post',
        data: data
    })
}

// 供应商预付款充值  
export function supplierReport(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/supplierReport',
        method: 'post',
        data: data
    })
}

// 批量删除supplier数据  
export function mergeDeleteSupplier(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/mergeDeleteSupplier',
        method: 'post',
        data: data
    })
}

// 供应商采购价新增
export function supplierPurchasesPrice_add(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierPurchasesPrice/add',
        method: 'post',
        data: data
    })
}

// 供应商采购价修改
export function supplierPurchasesPrice_update(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierPurchasesPrice/update',
        method: 'post',
        data: data
    })
}

// 供应商采购价查询
export function supplierPurchasesPrice_list(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierPurchasesPrice/selectSupplierPurchasesPriceList',
        method: 'post',
        data: data
    })
}

// 供应商采购价删除
export function supplierPurchasesPrice_delete(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierPurchasesPrice/delete',
        method: 'post',
        data: data
    })
}

// 供应商应收接口
export function getShouldPaymentMoneyTotalBySupplier(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesStatementDoc/getShouldPaymentMoneyTotalBySupplier',
        method: 'post',
        data: data
    })
}

//供应商应收汇总接口
export function getShouldPaymentMoneyTotalForSummary(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesStatementDoc/getShouldPaymentMoneyTotalForSummary',
        method: 'post',
        data: data
    })
}

//供应商已对账应收
export function getShouldPaymentMoneyTotalByCustomerForPurchasesStatementDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtPurchasesStatementDoc/getShouldPaymentMoneyTotalBySupplierForPurchasesStatementDoc',
        method: 'post',
        data: data
    })
}

//供应商未对账应收
export function getShouldPaymentMoneyTotalBySupplierForStatementPaymentDoc(data) {
    return request({
        url: '/qingguang/tenantbussiness/pmgtStatementPaymentDoc/getShouldPaymentMoneyTotalBySupplierForStatementPaymentDoc',
        method: 'post',
        data: data
    })
}

//所有供应商和价格
export function supplierPurchasesPrice_supplierPurchasesPriceList(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierPurchasesPrice/supplierPurchasesPriceList',
        method: 'post',
        data: data
    })
}

export function supplierPurchasesPrice_selectSupplierPurchasesPriceListByMaterialIdAndSpecGroupId(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplierPurchasesPrice/selectSupplierPurchasesPriceListByMaterialIdAndSpecGroupId',
        method: 'post',
        data: data
    })
}

//批量修改负责人
export function batchModifyCharge(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/batchModifyCharge',
        method: 'post',
        data: data
    })
}

// 根据产品查询供应商
export function supplier_getSupplierListByMaterialId(data) {
    return request({
        url: '/qingguang/tenantbussiness/supplier/getSupplierListByMaterialId',
        method: 'post',
        data: data
    })
}
